import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as constants from '../common/constants';
import * as JspUtil from '../common/JspUtil';
import submitHiddenForm from '../common/submitHiddenForm';
import { useJspVariables, useAppContext, useAuth, useDebugRender } from '../hooks';

const PagePasswordLessSamlSubmit = () => {
    useDebugRender('PagePasswordLessSamlSubmit');
    const navigate = useNavigate();
    const { jspVariables } = useJspVariables();
    const { getLoginApp } = useAppContext(jspVariables);

    const { authenticatedUser, isLauncherAuth } = useAuth();
    const PASSWORD_LESS_SAML_CONFIG = useSelector(state => state.userInputsReducer.PASSWORD_LESS_SAML_CONFIG);

    const redirectUrl = jspVariables.jspRedirectUrl || '';

    useEffect(() => {
        if (redirectUrl) {
            const appKey = isLauncherAuth ? authenticatedUser?.displayApp : getLoginApp();
            submitHiddenForm('/appUserLogin', {
                redirectUrl,
                loginUserId: '',
                passwordLessSamlConfigKeyName: PASSWORD_LESS_SAML_CONFIG ? PASSWORD_LESS_SAML_CONFIG.passwordLessSamlConfigKeyName : '',
                loginApp: appKey || '',
                isLauncher: isLauncherAuth ? 'Y' : 'N',
                samlSession: JspUtil.isValueAvailable(window.jspSamlSession) ? window.jspSamlSession : undefined,
                samlLogin: JspUtil.isValueAvailable(window.jspSamlLogin) ? window.jspSamlLogin : undefined,
                secondAuth: JspUtil.isValueAvailable(window.jspSecondAuth) ? window.jspSecondAuth : undefined,
            });
        } else {
            navigate(constants.ROUTE_PAGE_NOT_AUTHORIZED);
        }
    }, []);

    return null;
};

export default PagePasswordLessSamlSubmit;
